module.exports = __webpack_public_path__ + "a3322e35b3397a86f721552bf5039016.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/two-way-exchange-unread.svg
// module id = 128
// module chunks = 0